export default function(title) {
  const space = title.indexOf(" ");
  return !title || title[space] !== title[space + 1];
}